import { clx } from '@medusajs/ui';

interface FormFieldProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * A wrapper component for form fields that provides consistent flex column layout.
 * Use this to group a Label with its corresponding input element.
 */
export const FormField = ({ children, className }: FormFieldProps) => (
  <div className={clx('flex flex-col', className)}>{children}</div>
);

interface FormLabelProps {
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
}

/**
 * A styled label component for form fields.
 * Provides consistent text styling across all forms.
 */
export const FormLabel = ({ children, className, htmlFor }: FormLabelProps) => (
  <label htmlFor={htmlFor} className={clx('text-black-10 text-base', className)}>
    {children}
  </label>
);
